<template>
  <div class="empty-products-list">
    <img :src="iconImage" alt="Нічого не знайдено" class="image" />
    <div class="text">
      Нічого не знайдено<br />
      Змініть фільтри, щоб побачити більше товарів
    </div>
  </div>
</template>

<script>
import iconImage from "@/assets/shop/empty-list-icon.png";

export default {
  name: "EmptyProductsList",
  setup() {
    return {
      iconImage,
    };
  },
};
</script>

<style scoped lang="less">
@import "@/styles/_variables.less";

.empty-products-list {
  z-index: 1;
  position: absolute;
  height: calc(100vh - 116px);
  top: 116px;
  left: 0;
  right: 0;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;

  .image {
    max-width: 100%;
    width: 145px;
    height: auto;
    margin-bottom: 25px;

    @media @md {
      width: 200px;
    }

    @media @lg {
      width: 250px;
    }
  }

  .text {
    font-style: normal;
    font-weight: 400;
    font-size: 18px;
    line-height: 22px;
    color: #ffffff;
    margin-bottom: 30px;
  }
}
</style>
